import TicketFlyer from "./img/SponserTicket/SponserTicket.jpg";
import "./css/sponserTicket.css";
import { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { Form, Button, Modal } from "react-bootstrap";
import axiosInstance from "../utils/axiosInstance";
import Loader from "./Loader/Loader";

import { showSuccessToast, showErrorToast } from "./toast";

const generateCaptcha = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return captcha;
};

const SponserTicket = () => {
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [step, setStep] = useState(0);
  const [captchaInput, setCaptchaInput] = useState("");
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const [sucess, setSucess] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const otpLength = 6; // Define the length of the OTP
  const [otp, setOtp] = useState(Array(otpLength).fill(""));
  const inputsRef = useRef([]);
  const [isVerified, setIsVerified] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    ticket: "25",
    ticketCount: "1",
    comments: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleNextStep = () => {
    setStep((prev) => prev + 1);
  };

  const handleShow = () => setShow(true);
  const handleCloseX = () => {
    setShowConfirm(true); // open confirmation popup i
  };

  const handleClose = () => {
    setShow(false);
    setOtp(Array(otpLength).fill(""));
    setStep(0);

    setError("");
    setSucess("");
  };

  const handleEmailCode = async () => {
    setLoading(true);

    handleNextStep();
    setError("");
    handleShow();
    const res = await axiosInstance.post("/api/email/verify-email", {
      email: formData.email,
    });

    setLoading(false);
  };

  const handleResendCode = async () => {
    setLoading(true);
    const res = await axiosInstance.post("/api/email/resend-otp", {
      email: formData.email,
    });

    setError("");
    setSucess("Verification code resent to " + formData.email);
    setOtp(Array(otpLength).fill("")); // reset OTP inputs
    setLoading(false);
  };

  const handleChanges = (e, index) => {
    const value = e.target.value.replace(/\D/, ""); // only digits
    setSucess("");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    // onChanges && onChanges(newOtp.join(""));

    // move to next input
    if (index < otpLength - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (newOtp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
        // onChanges && onChanges(newOtp.join(""));
      } else if (index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handleVerifyEmail = async () => {
    setError("");
    try {
      const otpString = otp.join("");
      const response = await axiosInstance.post(
        "/api/otp/verifyOtp",
        { email: formData.email },
        { params: { otp: otpString } }
      );
      setIsVerified(true);
    } catch (error) {
      setError("Invalid verification code. Please try again.");
      setLoading(false);
      return;
    }

    setSucess("Email verified successfully!");
    handleNextStep();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isVerified) {
      showErrorToast("Please verify your email before submitting the form.");
      return;
    }

    // console.log(formData);
    setLoadings(true);
    try {
      const response = await axiosInstance.post(
        "/api/sponsor/request",
        formData
      );

      //   if (!response.ok) {
      //     throw new Error("Failed to send message");
      //   }

      //   const result = await response.json(); // parse JSON response
      //   console.log("Form submitted:", result);

      // show message
      showSuccessToast("Success! Your request has been submitted.");

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        ticket: "25",
        ticketCount: "1",
        comments: "",
      });
      setIsVerified(false);
      setCaptcha(generateCaptcha());
      setCaptchaInput("");
      setStep(0);
    } catch (error) {
      console.error("Error submitting form:", error);
      showErrorToast("Something went wrong. Please try again.");
    } finally {
      setLoadings(false);
    }
  };

  return (
    <>
      <div className="sponser-content main-content">
        {loadings && <Loader />}
        <h1 className="center-label auto-show mb-2 brand-text">
          MANO LIVE: Musical Show - Sponsor Tickets Request
        </h1>
        <div className="ticket-container">
          <div className="row mt-3 mb-5">
            <div className="col-lg-7 col-md-6 col-sm-12 mt-3 d-flex justify-content-center">
              <div className="flyer-container">
                {/* <img
                  src={TicketFlyer}
                  alt="Ticket Flyer"
                  className="ticket-img"
                /> */}
              </div>
            </div>
            <div className="col-lg-5 col-md-6 col-sm-12 mt-3">
              <div className="ticket-card">
                <Form onSubmit={handleSubmit}>
                  <div className="form-group mb-2">
                    <label>
                      First Name <span className="text-danger">*</span>
                    </label>
                    <input
                      id="formFirstName"
                      className="form-control"
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      placeholder="Enter first name"
                    />
                  </div>
                  <div className="form-group mb-2">
                    <label>
                      Last Name <span className="text-danger">*</span>
                    </label>
                    <input
                      id="formLastName"
                      className="form-control"
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      placeholder="Enter Last name"
                    />
                  </div>
                  <div className="form-group mb-2">
                    <label>
                      Phone <span className="text-danger">*</span>
                    </label>
                    <input
                      id="formPhone"
                      className="form-control"
                      type="tel"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                      placeholder="Enter phone number"
                    />
                  </div>
                  <div className="form-group mb-2 position-relative">
                    <label>
                      Email <span className="text-danger">*</span>
                    </label>
                    <div className="position-relative">
                      <input
                        id="formEmail"
                        className="form-control pe-5"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="Enter email"
                      />

                      {isVerified ? (
                        <span
                          className="text-success position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "1.2rem",
                          }}
                          title="Email verified"
                        >
                          {isVerified && "✓"}
                        </span>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary btn-sm position-absolute"
                          style={{
                            right: "5px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            padding: "0.25rem 0.5rem",
                            fontSize: "0.8rem",
                          }}
                          onClick={handleEmailCode}
                          disabled={!formData.email || loading}
                        >
                          {isVerified ? "Verified" : "Verify"}
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Ticket Type Radio Buttons */}
                  <div className="form-group mb-2 d-flex align-items-center">
                    <label className="me-3 mb-0">
                      Ticket <span className="text-danger">*</span>
                    </label>

                    {/* $25 Ticket */}
                    <div className="form-check form-check-inline d-flex align-items-center me-3">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ticket"
                        value="25"
                        checked={formData.ticket === "25"}
                        onChange={handleChange}
                        required
                        style={{
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      <label
                        className="form-check-label ms-1 mb-0"
                        style={{ cursor: "pointer", lineHeight: "16px" }}
                      >
                        $25
                      </label>
                    </div>

                    {/* $50 Ticket */}
                    <div className="form-check form-check-inline d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="ticket"
                        value="50"
                        checked={formData.ticket === "50"}
                        onChange={handleChange}
                        style={{
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      <label
                        className="form-check-label ms-1 mb-0"
                        style={{ cursor: "pointer", lineHeight: "16px" }}
                      >
                        $50
                      </label>
                    </div>
                  </div>

                  <div className="form-group mb-2">
                    <label>
                      Ticket Count <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      className="form-control"
                      name="ticketCount"
                      value={formData.ticketCount || ""}
                      onChange={handleChange}
                      required
                      placeholder="0"
                    />
                  </div>

                  {/* Comment Field */}
                  <div className="form-group mb-2">
                    <label>
                      Comment <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      name="comments"
                      value={formData.comments || ""}
                      onChange={handleChange}
                      placeholder="Add any comments or special requests"
                      rows={3}
                    ></textarea>
                  </div>

                  <Button
                    type="submit"
                    variant="primary"
                    className="w-100 btnmesg"
                    onClick={handleSubmit}
                    disabled={
                      !(
                        formData.firstName &&
                        formData.lastName &&
                        formData.phoneNumber &&
                        formData.email &&
                        formData.ticket &&
                        formData.ticketCount &&
                        formData.comments
                      )
                    }
                  >
                    Submit
                  </Button>
                </Form>

                <Modal
                  show={show}
                  onHide={handleClose}
                  backdrop="static"
                  keyboard={false}
                  centered
                  // style={{ maxWidth: '400px' , margin: '0 auto' }}
                  size="md"
                >
                  <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="w-100">
                      {step >= 1 && step <= 2 && (
                        <div>
                          <h5 className="fw-bold">
                            MANO LIVE: Musical Show - Sponsor Tickets Request
                          </h5>
                          <p
                            className={`text-muted mb-0 ${
                              step === 1 ? "poppara" : ""
                            }`}
                          >
                            <br />
                          </p>
                        </div>
                      )}
                    </Modal.Title>
                  </Modal.Header>

                  <Modal.Body className="pt-0">
                    {step === 1 && (
                      <div>
                        {loading ? (
                          <div className=" text-center">
                            <div className="mb-4 mt-4">
                              <h6 className="fw-bold mb-3">
                                Sending Verification Code...
                              </h6>
                              <p className="text-muted">
                                This may take a few moments.
                              </p>
                              <div className="loader"></div>
                            </div>
                          </div>
                        ) : (
                          <div className="verification-step">
                            <div className="text-center">
                              <div className="mb-4 mt-4">
                                <h6 className="fw-bold">
                                  Verify your email: {formData.email}
                                </h6>
                                <p className="text-muted mb-0">
                                  Please enter the verification code that has
                                  been sent to your email address.
                                </p>
                              </div>
                            </div>

                            {/* <hr className="my-4" /> */}

                            <div className="mb-4">
                              <label className="form-label fw-semibold">
                                Email verification code
                              </label>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "1rem",
                                }}
                              >
                                {otp.map((digit, idx) => (
                                  <input
                                    key={idx}
                                    type="text"
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) => handleChanges(e, idx)}
                                    onKeyDown={(e) => handleKeyDown(e, idx)}
                                    ref={(el) => (inputsRef.current[idx] = el)}
                                    style={{
                                      width: "2rem",
                                      height: "2rem",
                                      textAlign: "center",
                                      fontSize: "1.5rem",
                                      border: "none", // remove box
                                      // borderBottom: "2px solid #000", // optional underline style
                                      outline: "none",
                                      background: "transparent",
                                    }}
                                    placeholder="-"
                                  />
                                ))}
                              </div>
                            </div>

                            <div className="text-center">
                              {error && <p className="text-danger">{error}</p>}
                              {sucess && (
                                <p className="text-success">{sucess}</p>
                              )}
                            </div>

                            <hr className="my-4" />

                            <div className="d-flex justify-content-between align-items-center">
                              <button
                                variant="primary"
                                type="button"
                                className="btn"
                                style={{ padding: "5px" }}
                                onClick={handleResendCode}
                              >
                                Resend code
                              </button>

                              <button
                                variant="primary"
                                type="button"
                                className="btn btn-primary"
                                style={{ padding: "5px 15px" }}
                                onClick={handleVerifyEmail}
                                disabled={otp.includes("")}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {step === 2 && (
                      <div className="text-center mt-4">
                        <h5 className="text-success fw-bold">
                          Email Verified Successfully
                        </h5>
                        {/* <p className="text-muted">
                          Proceed with your sponsor ticket details.
                        </p> */}
                      </div>
                    )}
                  </Modal.Body>
                  <Modal.Footer className="border-0">
                    {step === 2 && (
                      <div>
                        <div className="w-100 d-flex justify-content-between">
                          <Button
                            variant="outline-secondary"
                            onClick={handleClose}
                          >
                            OK
                          </Button>
                        </div>
                      </div>
                    )}
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SponserTicket;
